
import Layout from '@/views/layout/Layout'
export default [
  {
    path: '/memberPoints',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '会员积分增长规则',
      icon: 'component'
    },
    children: [
      {
        path: '/memberPoints/memberPointsPage',
        component: () => import('@/myviews/memberPoints/memberPointsPage'),
        alwaysShow: false,
        name: '会员积分增长规则',
        meta: {
          title: '会员积分增长规则',
          icon: 'documentation',
          roles: ['add', 'modify', 'viewpage'],
          have: []
        }
      }
    ]
  }
]




// WEBPACK FOOTER //
// ./src/router/pointsManage/AD_memberPoints.js